<script lang="ts">
  import { formatIST } from '$lib/utils/dates';
  import { createQuery } from '@tanstack/svelte-query';
  import { adminLoginsApi } from '$lib/api/admin';
  import { getErrorMessage } from '$lib/api/client';
  import Modal from '$lib/components/ui/Modal.svelte';
  import Pagination from '$lib/components/ui/Pagination.svelte';
  import type { AdminUser } from '$lib/types';

  const { user, onClose }: { user: AdminUser; onClose: () => void } = $props();

  let page = $state(1);

  const loginsQuery = createQuery(() => ({
    queryKey: ['admin-user-logins', user.id, page],
    queryFn: () => adminLoginsApi.forUser(user.id, { page, per_page: 10 })
  }));
</script>

<Modal title={`Login activity — ${user.email}`} onClose={onClose} wide>
  {#if loginsQuery.isLoading}
    <p class="tym-loading-state">Loading logins&hellip;</p>
  {:else if loginsQuery.isError}
    <p class="tym-error-state">{getErrorMessage(loginsQuery.error)}</p>
  {:else if loginsQuery.data}
    <div class="tym-table-wrap">
      <div class="tym-table-scroll">
        <table class="tym-table">
          <thead>
            <tr>
              <th>Time</th>
              <th>IP</th>
              <th>Device</th>
            </tr>
          </thead>
          <tbody>
            {#each loginsQuery.data.results as row (row.id)}
              <tr>
                <td class="muted">{formatIST(row.created_at)}</td>
                <td class="muted font-heading">{row.ip_address || '—'}</td>
                <td>
                  <span class="tym-badge" style="background:#F1F0EF; color:#666">
                    {row.browser} &middot; {row.os} &middot; {row.device}
                  </span>
                </td>
              </tr>
            {:else}
              <tr><td class="empty" colspan="3">No logins recorded yet.</td></tr>
            {/each}
          </tbody>
        </table>
      </div>
    </div>
    <Pagination
      page={loginsQuery.data.page}
      perPage={loginsQuery.data.per_page}
      count={loginsQuery.data.count}
      onChange={(p) => (page = p)}
    />
  {/if}
</Modal>
